import React, { useContext } from 'react';
import '../../../styles/irctcPasswordSent.css';
import FacingTrouble from '../../components/FacingTrouble';
import { getAppEnv } from '../../../../config/env';
import {
  FACING_TROUBLE_PAGE_TITLE,
  getContinueBookingUrl,
  getFacingTroubleList,
  SERVER_URL
} from '../../../utils/RailsSEOConstants';
import axios from 'axios';
import fecha from 'fecha';
import { isMobile, navigateTo } from '../../../utils/commonUtils';
import { IrctcForgotUsernameContext } from '../IrctcForgotUserNamePage';
import useTimer from '../../components/useTimer';
import PropTypes from 'prop-types';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const IrctcUserNameSent = (props) => {
  const { customClass } = props;
  const context = useContext(IrctcForgotUsernameContext);
  const {
    forgotUserNameState: { userEmail, selectedDate }
  } = context;
  const { timerString, timerExpired } = useTimer(120);
  const handleResendUsernameClick = async () => {
    if (timerExpired) {
      try {
        // make API request
        await axios.get(`${SERVER_URL}/user/irctc/details/U`, {
          params: {
            userLoginId: '',
            email: userEmail || '',
            mobile: '',
            otpType: '',
            dob: fecha.format(selectedDate, 'YYYYMMDD') || ''
          }
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };
  const isMobileDevice = isMobile();

  return (
    <div className={`${customClass} irctcPwdSent`}>
      <div className="irctcPwdSent__cntnt">
        <div className="imgWrap">
          <img src={`${PUBLIC_URL}/static/public/tickIcon.png`} alt={''} />
        </div>
        <h3>New Username Sent</h3>
        <div>
          <span className="appendBottom40">
            Your new username has been sent to your registered email address{' '}
            <span className="latoBlack">{`${userEmail}`}</span>
          </span>
        </div>
        <div className="makeFlex hrtlCenter appendTop10">
          <span className="appendRight15">Didn’t receive Username?</span>
          <p className="timeTag">
            <span className="railSeoSprite whiteClock appendRight8"></span>
            {timerString}
          </p>
        </div>
        <a onClick={handleResendUsernameClick} className={timerExpired ? '' : 'noDrop'}>
          Resend Username
        </a>
        <button
          className={`blueButtonRails ${isMobileDevice ? 'fullWidth' : ''} `}
          onClick={() => navigateTo(getContinueBookingUrl())}
        >
          Continue Booking
        </button>
      </div>
      <FacingTrouble facingTroubleList={getFacingTroubleList(FACING_TROUBLE_PAGE_TITLE.FORGOT_IRCTC_USERNAME_TITLE)} />
    </div>
  );
};

IrctcUserNameSent.propTypes = {
  customClass: PropTypes.string
};

export default IrctcUserNameSent;
